import { Helmet } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import About from "@/components/About";
import Footer from "@/components/Footer";

const AboutPage = () => {
  return (
    <div className="min-h-screen overflow-hidden">
      <Helmet>
        <title>About | Priya Pareek</title>
        <meta
          name="description"
          content="Learn more about Priya Pareek, a visual artist and designer with over a decade of experience in visual arts, design, and creative direction."
        />
      </Helmet>
      <Navbar />
      <About />
      <Footer />
    </div>
  );
};

export default AboutPage;